import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom"; 
import axios from "axios";
import { useDispatchCart } from "../../../store/ContextReducer"; 
import { useAuth } from "../../../store/AuthContext"; 
import { ApiPath, ApiPathQuiz, googleMapAPI } from "../../../config"; 
import { useLocation } from "react-router-dom";
import "./cart.css";
import { myColors } from "../../../contants/Colors";
import { toast } from "react-toastify";
import { ArrowBackIosNew } from "@mui/icons-material";
import AdjustIcon from "@mui/icons-material/Adjust";

const OrderSummary = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatchCart();
  const { menuData, selectedAddress, totalAmount, discount, subtotal, GST } =
    location.state || {};
  
  const [isLoading, setIsLoading] = useState(false);
  const [distance, setDistance] = useState(0);
  const [deliveryCharges, setDeliveryCharges] = useState(50);
  const [finalAmount, setFinalAmount] = useState(totalAmount);
  const { isAuthenticated } = useAuth();
  
  // --- NEW STATE FOR SERVICEABILITY & GIVEAWAY ---
  const [isServiceable, setIsServiceable] = useState(true);
  const [giveAwayCouponData, setGiveAwayCouponData] = useState(null);
  const [giveAwayCouponApplied, setGiveAwayCouponApplied] = useState(false);
  
  const [couponApplied, setCouponApplied] = useState(false);
  const [gameCouponApplied, setGameCouponApplied] = useState(false);
  const [couponData, setCouponData] = useState(null);
  const [couponDiscount, setCouponDiscount] = useState(0);
  const [buy2Applied, setBuy2Applied] = useState(false);

  const FREE_DELIVERY_CODE = "FREEDELIVERY1000";
  const OFFER_END_DATE = new Date("2024-11-13T23:59:59"); 

  // YOUR API KEY FROM PROMPT
  // const GOOGLE_API_KEY = "AIzaSyACbEJThhqjXiiOtZiogD2I77RFO2Q5uFM";

  if (!isAuthenticated) {
    toast.error("Please login to order");
    navigate('/AuthPage');
  }

  // 1. Fetch Quiz Coupon
  useEffect(() => {
    const fetchCoupon = async () => {
      const userEmail = localStorage.getItem("userEmail");
      try {
        const response = await axios.get(`${ApiPathQuiz}/${userEmail}`);
        if (response.data) {
          setCouponData(response.data);
        }
      } catch (error) {
        console.error("Error fetching coupon data:", error);
      }
    };
    fetchCoupon();
  }, []);

  // 2. Fetch Giveaway Coupon
  useEffect(() => {
    const fetchGiveAwayCoupon = async () => {
      const userEmail = localStorage.getItem("userEmail");
      try {
        const response = await axios.get(`${ApiPath}/jaavapotFreeGiveAway/freegiveaway/${userEmail}`);
        if (response.data) {
          setGiveAwayCouponData(response.data);
        }
      } catch (error) {
        // console.error("Error fetching giveaway data:", error);
      }
    };
    fetchGiveAwayCoupon();
  }, []);

  // 3. Recalculate Final Amount
  useEffect(() => {
    if (!giveAwayCouponApplied) {
      let discountedAmount = subtotal - couponDiscount;
      const roundedAmount = Math.round(discountedAmount + deliveryCharges + GST);
      setFinalAmount(roundedAmount);
    }
  }, [subtotal, deliveryCharges, couponDiscount, GST, giveAwayCouponApplied]);

  // Prevent back button
  useEffect(() => {
    const handleBeforeUnload = (event) => {
      event.preventDefault();
      event.returnValue = "";
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  // --- HELPER: DEG TO RAD ---
  const deg2rad = (deg) => {
    return deg * (Math.PI / 180);
  };

  // --- HELPER: HAVERSINE FORMULA FOR DISTANCE ---
  const getDistanceFromLatLonInKm = (lat1, lon1, lat2, lon2) => {
    const R = 6371; // Radius of the earth in km
    const dLat = deg2rad(lat2 - lat1);
    const dLon = deg2rad(lon2 - lon1);
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const d = R * c; // Distance in km
    return d;
  };

  // --- DELIVERY CHARGE LOGIC ---
  const calculateDeliveryCharges = (distance, subtotal) => {
    let deliveryCharge = 0;
    let comboCategory = null;

    if (distance < 100) deliveryCharge = 49;
    else if (distance >= 100 && distance < 200) deliveryCharge = 69;
    else if (distance >= 200 && distance < 500) deliveryCharge = 69;
    else if (distance >= 500 && distance < 700) deliveryCharge = 99;
    else if (distance >= 700 && distance < 1000) deliveryCharge = 99;
    else if (distance >= 1000) deliveryCharge = 99;

    const isComboOrSubscription = menuData.some(
      (item) =>
        item.maincategory?.toLowerCase() === "combos" ||
        item.maincategory?.toLowerCase() === "subscription"
    );

    menuData.forEach((item) => {
      if (item.category?.toLowerCase() === "combo-3") {
        deliveryCharge = 49;
        comboCategory = "combo-3";
      } else if (item.category?.toLowerCase() === "combo-5") {
        deliveryCharge = 49;
        comboCategory = "combo-5";
      } else if (item.category?.toLowerCase() === "combo-10") {
        deliveryCharge = 0;
        comboCategory = "combo-10";
      }
    });

    if (isComboOrSubscription) {
      deliveryCharge = 49;
    }
    
    if (subtotal > 1000) {
      deliveryCharge = 0;
      toast.success(`Coupon applied! ${FREE_DELIVERY_CODE} You Saved Delivery Charges.`);
    }

    if (comboCategory) {
      toast.success(`Delivery charge for ${comboCategory} is ₹${deliveryCharge}.`);
    }

    return deliveryCharge;
  };

  const CurrentCafeLocation =
    "16-11-741/D/106, Shalivahana Nagar Malakpet, Hyderabad - 500036, Telangana";

  // --- FETCH DISTANCE (USING GEOCODING + HAVERSINE) ---
  useEffect(() => {
  const fetchDistance = async () => {
    if (!selectedAddress || !selectedAddress.Location) {
      setDeliveryCharges(50);
      return;
    }

    setIsLoading(true);

    // 1. Static Cafe Coordinates
    const shopLoc = { lat: 17.375271, lng: 78.491224 }; 
    const userAddress = `${selectedAddress.Location}, ${selectedAddress.City}, ${selectedAddress.Pincode}, India`;

    // 2. Use the Google Maps JS SDK Geocoder
    const geocoder = new window.google.maps.Geocoder();

    geocoder.geocode({ address: userAddress }, (results, status) => {
      if (status === "OK" && results[0]) {
        const userLoc = results[0].geometry.location;
        
        // Convert SDK location object to standard lat/lng numbers
        const userLat = userLoc.lat();
        const userLng = userLoc.lng();

        // 3. Calculate Distance using your Haversine function
        const calculatedDistance = getDistanceFromLatLonInKm(
          shopLoc.lat,
          shopLoc.lng,
          userLat,
          userLng
        );

        setDistance(calculatedDistance);
        console.log("Verified Distance:", calculatedDistance);

        // 4. Serviceability Logic
        const hasReadyToEatItems = menuData.some(item => item.maincategory === "ReadyToEat");

        if (hasReadyToEatItems && calculatedDistance > 10) {
          setIsServiceable(false);
          setDeliveryCharges(0);
          toast.error("Ready to Eat orders are only available within 10 km.");
        } else {
          setIsServiceable(true);
          const charge = calculateDeliveryCharges(calculatedDistance, subtotal);
          setDeliveryCharges(charge);
        }
        setIsLoading(false);
      } else {
        console.error("Geocode failed: " + status);
        setIsLoading(false);
        setDeliveryCharges(50); // Fallback
        if (status === "REQUEST_DENIED") {
          toast.error("Google API Access Denied. Check Billing & Geocoding API status.");
        }
      }
    });
  };

  fetchDistance();
}, [selectedAddress, menuData, subtotal]);
  // useEffect(() => {
  //   const fetchDistance = async () => {
  //     setIsLoading(true);
  //     try {
  //       const cafeAddress = CurrentCafeLocation;

  //       if (selectedAddress) {
  //         // Construct User Address String
  //         const userAddress = `${selectedAddress.Location}, ${selectedAddress.City}, ${selectedAddress.Pincode}`;
          
  //         // 1. Get Coordinates for Shop (Cafe)
  //         const shopRes = await axios.get(
  //           `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(cafeAddress)}&key=${googleMapAPI}`
  //         );

  //         // 2. Get Coordinates for User
  //         const userRes = await axios.get(
  //           `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(userAddress)}&key=${googleMapAPI}`
  //         );

  //         if (
  //           shopRes.data.status === "OK" && 
  //           userRes.data.status === "OK" &&
  //           shopRes.data.results.length > 0 &&
  //           userRes.data.results.length > 0
  //         ) {
  //             const shopLoc = shopRes.data.results[0].geometry.location;
  //             const userLoc = userRes.data.results[0].geometry.location;

  //             // 3. Calculate Distance locally
  //             const calculatedDistance = getDistanceFromLatLonInKm(
  //                 shopLoc.lat,
  //                 shopLoc.lng,
  //                 userLoc.lat,
  //                 userLoc.lng
  //             );

  //             setDistance(calculatedDistance);
  //             console.log("Calculated Distance (KM):", calculatedDistance);

  //             // 4. Apply Serviceability Logic
  //             const hasReadyToEatItems = menuData.some(
  //               (item) => item.maincategory === "ReadyToEat"
  //             );

  //             // If ReadyToEat items exist AND distance > 10km -> BLOCK
  //             if (hasReadyToEatItems && calculatedDistance > 10) {
  //               setIsServiceable(false);
  //               setDeliveryCharges(0);
  //               toast.error("Ready to Eat orders are only available within a 10 km radius.");
  //             } else {
  //               setIsServiceable(true);
  //               const deliveryCharge = calculateDeliveryCharges(calculatedDistance, subtotal);
  //               setDeliveryCharges(deliveryCharge);
  //             }
  //         } else {
  //             console.error("Geocoding failed or no results found.");
  //             setDeliveryCharges(50); // Fallback
  //         }
  //       } else {
  //         setDeliveryCharges(50);
  //       }
  //     } catch (error) {
  //       console.error("Error calculating distance:", error);
  //       setDistance(0);
  //       setDeliveryCharges(50);
  //     } finally {
  //       setIsLoading(false);
  //     }
  //   };

  //   fetchDistance();
  // }, [selectedAddress, menuData, subtotal]); 

  // --- COUPON LOGIC ---
  const applyQuizCoupons = () => {
    let discountedSubtotal = subtotal;
    const firstDiscount = discountedSubtotal * 0.1;
    discountedSubtotal -= firstDiscount;
    setCouponDiscount(subtotal - discountedSubtotal);
    setCouponApplied(true);
    setGameCouponApplied(true);
    toast.success("10% discounts applied successfully!");
  };

  const applyBuy2Get1FreeOffer = () => {
    const isComboOrSubscription = menuData.some(
        (item) =>
          item.maincategory.toLowerCase() === "combos" ||
          item.maincategory.toLowerCase() === "subscription"
      );

    if (isComboOrSubscription) {
      toast.error("Buy 2 Get 1 Free offer is not applicable for Combos or Subscriptions.");
      return;
    }
    
    const totalQty = menuData.reduce((sum, item) => sum + item.qty, 0);

    if (totalQty >= 3) {
      const cheapestItem = menuData.reduce((minItem, item) => 
        item.basicPrice < minItem.basicPrice ? item : minItem, 
        menuData[0]
      );
      setCouponDiscount(cheapestItem.basicPrice);
      toast.success(`Buy 2 Get 1 Free offer applied! Discount: ₹${cheapestItem.basicPrice}`);
      setBuy2Applied(true);
    } else {
      toast.info("Add at least 3 products to avail this offer");
    }
  };

  // --- GIVEAWAY LOGIC ---
  const applyGiveAwayCoupon = () => {
    const totalQuantity = menuData.reduce((sum, item) => sum + item.qty, 0);
    const isEligible = totalQuantity <= 2;
  
    if (!isEligible) {
        toast.warn("Note: This giveaway coupon allows a maximum of 2 items per order.");
        return;
    }
  
    const currentDate = new Date();
    if (currentDate <= OFFER_END_DATE) {
        setFinalAmount(0); // Free Order
        setGiveAwayCouponApplied(true);
        setCouponApplied(true);
        setGameCouponApplied(true); 
        toast.success("Free Giveaway Coupon Applied! Happy Diwali!");
    } else {
        toast.error("This coupon has expired!");
    }
  };

  // --- UPDATE STATUS ---
  const updateStatusToInactive = async () => {
    if (!gameCouponApplied) return;
    
    if (couponData && !giveAwayCouponApplied) {
        try {
            await axios.put(`${ApiPathQuiz}/${couponData._id}/status`, { status: 'inactive' });
        } catch (error) {
            console.error('Error updating quiz status:', error);
        }
    }
  };

  const updateGiveAwayCoponStatusToInactive = async () => {
    if (!giveAwayCouponApplied || !giveAwayCouponData) return;
    try {
        await axios.put(`${ApiPath}/jaavapotFreeGiveAway/freegiveaway/${giveAwayCouponData._id}/status`, {
             status: 'inactive',
        });
    } catch (error) {
        console.error('Error updating giveaway status:', error);
    }
  };

  // --- ORDER PLACEMENT (STANDARD) ---
  const handleCheckOut = async (amount) => {
    if (!isServiceable) {
        toast.error("Your location is outside our 10km delivery radius.");
        return;
    }

    try {
      const { data: { key } } = await axios.get(`${ApiPath}jaavapotpayment/api/getkey`);
      const { data: { order } } = await axios.post(`${ApiPath}jaavapotpayment/checkout`, { amount });

      const options = {
        key,
        amount: order.amount,
        currency: "INR",
        name: "Jaavapot",
        description: "Food ordering",
        order_id: order.id,
        handler: async function (response) {
          let userEmail = localStorage.getItem("userEmail");
          
          const { razorpay_order_id, razorpay_payment_id, razorpay_signature } = response;
          const paymentDetail = {
            totalAmount: amount,
            orderId: razorpay_order_id,
            paymentId: razorpay_payment_id,
            paymentSignature: razorpay_signature
          };

          let responses = await axios.post(`${ApiPath}jaavapotorders/api/orders`, {
            order_data: [menuData, selectedAddress, paymentDetail],
            email: userEmail,
          });

          let responseToKitchen = await axios.post(
            `${ApiPath}jaavapotemailnotification/send-email`,
            {
              emailid: "haseelaboina@pagoanalytics.com",
              order_data: [menuData, selectedAddress],
            }
          );

          if (responses.status === 200 && responseToKitchen.status === 200) {
            dispatch({ type: "DROP" });
            toast.success("Your Order is Successfully Placed and will be delivered soon.");
            updateStatusToInactive();
            navigate("/orders");
          }
        },
        prefill: {
          name: selectedAddress.name,
          email: selectedAddress.delivery_email,
          contact: selectedAddress.delivery_phone,
        },
        notes: {
          city: selectedAddress.City,
          address: selectedAddress.Location,
          pincode: selectedAddress.Pincode,
          landmark: selectedAddress.Landmark,
        },
        theme: { color: "#FD7E4B" },
      };

      const rzp = new window.Razorpay(options);
      rzp.open();
    } catch (error) {
      console.error(error);
    }
  };

  // --- ORDER PLACEMENT (FREE GIVEAWAY) ---
  const handlePlaceGiveAwayOrder = async () => {
    if (!isServiceable) {
        toast.error("Your location is outside our 10km delivery radius.");
        return;
    }

    try {
        let userEmail = localStorage.getItem("userEmail");
        const paymentDetail = {
            totalAmount: finalAmount, 
            orderId: "Order with give away coupon",
            paymentId: "No Payment",
            paymentSignature: "Free"
        };

        let responses = await axios.post(`${ApiPath}jaavapotorders/api/orders`, {
            order_data: [menuData, selectedAddress, paymentDetail],
            email: userEmail,
        });

        let responseToKitchen = await axios.post(
            `${ApiPath}jaavapotemailnotification/send-email`,
            {
                emailid: "orders@thejaavapot.com",
                order_data: [menuData, selectedAddress],
            }
        );

        if (responses.status === 200 && responseToKitchen.status === 200) {
            dispatch({ type: "DROP" });
            toast.success("Your Free Order is Successfully Placed!");
            updateGiveAwayCoponStatusToInactive();
            navigate("/orders");
        }
    } catch (error) {
        console.error("Giveaway order placement failed", error);
        toast.error("Failed to place order. Please try again.");
    }
  };

  if (isLoading) {
    return (
      <div className="loading-container">
        <div className="spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }

  return (
    <div className="my" style={{ backgroundColor: "#FDF0DD" }}>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <p
          style={{
            fontWeight: 700,
            fontFamily: "Arial",
            fontSize: "36px",
            fontStyle: "italic",
            color: "#FD7E4B",
          }}
        >
          Order Summary
        </p>
        <div
          onClick={() => navigate(-1)}
          style={{
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
            backgroundColor: "#FF9A7233",
            padding: "10px",
            borderRadius: "15px",
          }}
        >
          <ArrowBackIosNew style={{ color: "#000", fontSize: "20px" }} />
          <span
            style={{
              marginLeft: "8px",
              fontSize: "16px",
              color: "#0D0D0D",
              fontWeight: 400,
              fontFamily: "Arial",
            }}
          >
            Back To Cart
          </span>
        </div>
      </div>
      
      {/* Menu List */}
      {menuData.length === 0 ? (
        <div className="empty-cart">
          <p>Your Cart is Empty!</p>
        </div>
      ) : (
        <div className="menu-list">
          <div>
            {menuData.length > 0 && (
              <div className="cart-headings">
                <div className="heading-image"><strong>Picture</strong></div>
                <div className="heading-name"><strong>Name</strong></div>
                <div className="heading-base-price"><strong>Base Price</strong></div>
                <div className="heading-price"><strong>Price</strong></div>
                <div className="heading-tax"><strong>Other</strong></div>
                <div className="heading-total"><strong>Total</strong></div>
              </div>
            )}

            {menuData.map((item, index) => (
              <div className="cart-item" key={index}>
                <div className="heading-image">
                  <img src={item.img} alt={item.name} className="item-image" />
                </div>
                <div className="heading-name">
                  <h4 className="valueStylesName">{item.name}</h4>
                </div>
                <div className="heading-base-price">
                  <p className="valueStyles">₹{item.basicPrice}</p>
                </div>
                <div className="heading-price">
                  <p className="valueStyles">₹ {item.basicPrice * item.qty}</p>
                </div>
                <div className="heading-tax">
                  <p className="valueStyles">₹ {(item.basicPrice * item.qty * 0.18).toFixed(2)}</p>
                </div>
                <div className="heading-total">
                  <p className="valueStyles">₹ {(item.basicPrice * item.qty * 1.18).toFixed(2)}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Address Section */}
      <div className="address-container">
        <p
          style={{
            fontWeight: 700,
            fontFamily: "Arial",
            fontSize: "36px",
            fontStyle: "italic",
            color: "#FD7E4B",
          }}
        >
          Delivery Address
        </p>
        {selectedAddress ? (
          <div className="address-item" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div>
              <p>{selectedAddress.name}</p>
              <p>{`${selectedAddress.Location}, ${selectedAddress.City}, ${selectedAddress.State} - ${selectedAddress.Pincode}`}</p>
              <p>{`Phone: ${selectedAddress.delivery_phone}`}</p>
              {selectedAddress.delivery_email && (
                <p>{`Email: ${selectedAddress.delivery_email}`}</p>
              )}
              {/* WARNING MESSAGE */}
              {!isServiceable && (
                  <p style={{ color: 'red', fontWeight: 'bold', marginTop: '10px' }}>
                    ⚠️ Delivery not available (Distance: {distance.toFixed(1)}km, Max: 10km for ReadyToEat)
                  </p>
              )}
            </div>
            <div className="icon-container">
              <AdjustIcon sx={{ color: "#F67939", fontSize: "50px" }} />
            </div>
          </div>
        ) : (
          <p>No Address Selected</p>
        )}
      </div>

      {/* Summary Box */}
      <div className="summary-box">
        <div className="summary-row">
          <p>Subtotal</p>
          <p>{subtotal} ₹</p>
        </div>
        <div className="summary-row">
          <p>Delivery Charge</p>
          <p>{deliveryCharges} ₹</p>
        </div>
        <div className="summary-row">
          <p>Other</p>
          <p>{GST.toFixed(2)} ₹</p>
        </div>
        <div className="summary-row">
          <p>Discount</p>
          {giveAwayCouponApplied ? (
               <p>- {totalAmount + deliveryCharges + GST} ₹</p>
          ) : (
               <p>- {couponDiscount.toFixed(2)} ₹</p>
          )}
        </div>
        <div className="summary-row total-amount">
          <p style={{ color: myColors.primaryOrange, fontWeight: "700", fontSize: "24px" }}>
            Total Amount
          </p>
          <p style={{ color: myColors.primaryOrange, fontWeight: "700", fontSize: "24px" }}>
            {finalAmount} ₹
          </p>
        </div>

        {/* Buttons Section */}
        {isServiceable ? (
            <>
                {/* 1. Quiz Coupon Button */}
                {!gameCouponApplied && couponData?.status === "active" && (
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <button
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '14px',
                        fontWeight: '400',
                        borderRadius: '20px',
                        maxWidth: '490px',
                        padding: '10px 40px',
                        width: '100%'
                    }}
                    onClick={applyQuizCoupons}
                    >
                    <span>Apply TJPDD24N Game Coupon for 10% Off</span>
                    </button>
                </div>
                )}

                {/* 2. Buy 2 Get 1 Button */}
                {!buy2Applied && !gameCouponApplied && (
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <button
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        fontSize: '20px',
                        fontWeight: '500',
                        borderRadius: '20px',
                        maxWidth: '490px',
                        padding: '10px 40px',
                        width: '100%'
                    }}
                    onClick={applyBuy2Get1FreeOffer}
                    >
                    <span>Apply Buy 2 Get 1 Free Offer</span>
                    </button>
                </div>
                )}

                {/* 3. Giveaway Coupon Button */}
                {!giveAwayCouponApplied && giveAwayCouponData?.status === "active" && (
                     <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <button
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            fontSize: '18px',
                            fontWeight: '500',
                            borderRadius: '20px',
                            maxWidth: '490px',
                            padding: '10px 40px',
                            width: '100%'
                        }}
                        onClick={applyGiveAwayCoupon}
                        >
                        <span>Apply Free Give Away Coupon WELCOME2024</span>
                        </button>
                    </div>
                )}

                {/* 4. Payment / Place Order Buttons */}
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                {!giveAwayCouponApplied ? (
                    <button
                        style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        fontSize: '24px',
                        fontWeight: '600',
                        borderRadius: '20px',
                        maxWidth: '490px',
                        padding: '10px 40px',
                        width: '100%'
                        }}
                        onClick={() => handleCheckOut(finalAmount)}
                    >
                        <span style={{ marginRight: 'auto' }}>Place Order</span>
                        {buy2Applied && <span style={{ textDecoration: 'line-through', marginRight: '5px' }}>₹{finalAmount + couponDiscount} </span>}
                        <span style={{ marginLeft: '8px' }}>₹{finalAmount}</span>
                    </button>
                ) : (
                    <button
                        style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        fontSize: '24px',
                        fontWeight: '600',
                        borderRadius: '20px',
                        maxWidth: '490px',
                        padding: '10px 40px',
                        width: '100%'
                        }}
                        onClick={handlePlaceGiveAwayOrder}
                    >
                        <span>Place Free Give Order</span>
                    </button>
                )}
                </div>
            </>
        ) : (
            // NOT SERVICEABLE MESSAGE
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <button
                disabled
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    fontSize: '18px',
                    fontWeight: '600',
                    borderRadius: '20px',
                    maxWidth: '490px',
                    padding: '15px 40px',
                    width: '100%',
                    backgroundColor: '#ccc',
                    cursor: 'not-allowed',
                    color: '#666'
                }}
                >
                <span>Delivery Unavailable ({'>'}10km) 😔</span>
                </button>
            </div>
        )}

      </div>
    </div>
  );
};

export default OrderSummary;